"use client";

import { generateUUID } from "@opensea/utils";
import { LayoutGroup } from "motion/react";
import { useRef } from "react";

/**
 * Really simple convenience helper for making isolated framer motion component layout groups.
 */
export const NamespacedLayoutGroup = props => {
  const id = useRef(generateUUID());
  return <LayoutGroup id={id.current} {...props} />;
};